module.exports = __webpack_public_path__ + "img/green-gross-icon.119ff626.svg";